export const SUBMIT_DELIVERY_EXCELLENCE_REQUEST = "SUBMIT_DELIVERY_EXCELLENCE_REQUEST";
export const SUBMIT_DELIVERY_EXCELLENCE_SUCCESS = "SUBMIT_DELIVERY_EXCELLENCE_SUCCESS";
export const SUBMIT_DELIVERY_EXCELLENCE_FAILURE = "SUBMIT_DELIVERY_EXCELLENCE_FAILURE";

export const submitDeliveryExcellenceRequest = (formData) => {
    return (dispatch) => {
        dispatch({
            type: SUBMIT_DELIVERY_EXCELLENCE_REQUEST,
            payload: formData,
        });
    };
};

export const submitDeliveryExcellenceSuccess = (message) => ({
  type: SUBMIT_DELIVERY_EXCELLENCE_SUCCESS,
  payload: message,
});

export const submitDeliveryExcellenceFailure = (error) => ({
  type: SUBMIT_DELIVERY_EXCELLENCE_FAILURE,
  payload: error,
});